import { Col, Drawer, Input, Radio, Row, Select, Space } from "antd";
import React, { useCallback, useRef, useState } from "react";
import { useEffect } from "react";
import "./SearchDropDown.css";

import { IoIosArrowDown } from "react-icons/io";
import Loader from "../Loading/Loader";
import {
  CloseOutlined,
  LoadingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { isNull } from "../../shared/helpers";

const SearchDropDown = ({
  isMobileView,
  label = "",
  name,
  value,
  list = [],
  dispatchFunction,
  loading = true,
  otherPayload = {},
  onSelect = () => {},
  disabled = false,
  getFullName = () => {},
  selectedId,
  selectedAbs = {},
  isChild,
}) => {
  const dropDownButtonRef = useRef(null);
  const dropDownRef = useRef(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filterName, setFilterName] = useState(name);
  const [isShowDrawer, setIsShowDrawer] = useState(false);
  useBlurEffect(dropDownRef, dropDownButtonRef, setDropdownVisible);
  const dispatch = useDispatch();

  const handleDefaultValue = () => {
    setFilterName(null);
    setDropdownVisible(false);
    onSelect({});
  };

  const handleSelect = (e, user) => {
    e.stopPropagation();
    setFilterName(getFullName(user));
    setDropdownVisible(false);
    onSelect(user);
  };

  const onSelectAbsAsChild = (e, isWeb = true) => {
    e.stopPropagation();
    handleSelect(e, {
      FirstName: selectedAbs.name,
      AccountId: selectedAbs.id,
      isWeb,
    });
  };

  const handleInput = (e) => {
    const params = e.target.value;
    searchDebounce(params);
  };

  const searchDebounce = useCallback(
    _.debounce((e) => {
      handleSearch(e);
    }, 500),
    []
  );

  const handleSearch = (e) => {
    dispatch(dispatchFunction({ ...otherPayload, search: e }));
  };

  useEffect(() => {
    setFilterName(isNull(value) ? name : value);
  }, [value]);

  const closeDrawer = () => {
    setIsShowDrawer(false);
  };

  const onSelectRadio = (e) => {
    // to select All
    if (isNull(e.target.value)) {
      onSelect({ isWeb: false });
      return;
    }
    const user = list.find(
      (el) =>
        +el?.ABSProfileId == +e.target.value ||
        +el?.AccountId == +e.target.value
    );
    setIsShowDrawer(false);
    if (user == undefined && isChild) {
      onSelectAbsAsChild(e, false);
      return;
    }

    onSelect({ ...user, isWeb: false });
  };

  if (isMobileView)
    return (
      <>
        <Drawer
          open={isShowDrawer}
          placement="top"
          height={"100vh"}
          closable={false}
          title={
            <div>
              <Row justify={"space-between"}>
                <Col
                  className={"clearAll"}
                  style={{ justifyContent: "flex-start" }}
                >
                  Select {label}
                </Col>

                <Col
                  style={{ textAlign: "center", cursor: "pointer" }}
                  onClick={closeDrawer}
                >
                  <CloseOutlined style={{ color: "#9e9e9e" }} />
                </Col>
              </Row>
            </div>
          }
        >
          <Row>
            <Col span={24}>
              <Input
                type="text"
                placeholder={"Find " + label}
                onChange={(e) => handleInput(e)}
                allowClear
                prefix={<SearchOutlined />}
                autoFocus={true}
              />
              {loading ? (
                <div style={{ margin: "auto", padding: "10px 0px" }}>
                  <LoadingOutlined />
                </div>
              ) : (
                <Radio.Group
                  style={{ width: "100%" }}
                  onChange={onSelectRadio}
                  value={selectedId}
                >
                  <Space
                    direction="vertical"
                    style={{ display: "flex", paddingTop: "10px" }}
                  >
                    <Radio className="search-radio-btn" value={null}>
                      {"All " + label}
                    </Radio>
                   {isChild && selectedAbs?.id && selectedAbs?.name ? (
  <Radio className="search-radio-btn" value={selectedAbs.id}>
    {selectedAbs?.name}
  </Radio>
) : null}
                    {list.map((item, index) => (
                      <>
                        <Radio
                          className="search-radio-btn"
                          value={item?.AccountId || item?.ABSProfileId}
                          key={index}
                        >
                          {getFullName(item)}
                        </Radio>
                      </>
                    ))}
                  </Space>
                </Radio.Group>
              )}
            </Col>
          </Row>
        </Drawer>
        <div className="jobStatusDropDownText">{label}</div>
        <Select
          disabled={disabled}
          value={isNull(value) ? undefined : value}
          placeholder={"Find " + label}
          className={`${
            disabled ? "grey-disable-bkg" : ""
          } track-search-select`}
          mode="single"
          bordered={false}
          onClick={() => {
            if (disabled) return;
            setIsShowDrawer(true);
          }}
          showSearch
          listHeight={160}
          open={false}
        ></Select>
      </>
    );

  return (
    <>
      <div className="DropdownFilterContainer">
        <div
          ref={dropDownButtonRef}
          className={`${
            disabled ? "grey-disable-bkg" : ""
          } selectedDropdownFilter`}
          onClick={(e) => {
            e.stopPropagation();
            if (disabled) return;
            setDropdownVisible(!dropdownVisible);
          }}
          disabled={disabled}
        >
          <span>{filterName}</span>
          {disabled ? null : <IoIosArrowDown />}
        </div>
        {dropdownVisible && (
          <div className="optionDropdownFilter" ref={dropDownRef}>
            <div className="CampaignsSearch">
              <Input
                type="text"
                placeholder="Search..."
                onChange={(e) => handleInput(e)}
                allowClear
                autoFocus={true}
              />
            </div>
            {loading ? (
              <div style={{ margin: "auto", padding: "10px 0px" }}>
                <LoadingOutlined />
              </div>
            ) : (
              <>
                <span onClick={(e) => handleDefaultValue()}>
                  <span className="campaignTitle">{name}</span>
                </span>
                {isChild && selectedAbs?.name !== null && selectedAbs?.name !== undefined ? (
  <span onClick={(e) => onSelectAbsAsChild(e)}>
    <span className="campaignTitle">{selectedAbs?.name}</span>
  </span>
) : null}
                {list.map(({ key, ...user }, i) => {
                  return (
                    <span key={i} onClick={(e) => handleSelect(e, user)}>
                      <span className="campaignTitle">{getFullName(user)}</span>
                    </span>
                  );
                })}
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default SearchDropDown;

export const useBlurEffect = (inputRef, inputRef2, callbackFunction) => {
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target) &&
        !inputRef2.current.contains(e.target)
      ) {
        callbackFunction(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [inputRef, inputRef2]);
};
